var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcAddItems2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_164:895)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.9025 13.6486L18.0621 21.3513C17.8742 21.7343 17.3416 22.1394 16.9303 22.1394L1.52902 22.1424C1.20365 22.1424 0.891697 22.0057 0.661794 21.7618C0.431892 21.518 0.302734 21.1877 0.302734 20.8428L0.305227 7.16911C0.305227 6.45238 0.853496 5.87081 1.5299 5.87011L2.65595 5.86899V6.9761H1.90259C1.75514 6.9761 1.61352 7.03811 1.50918 7.14868C1.40495 7.25925 1.34633 7.40922 1.34633 7.56559L1.34743 20.4462C1.34743 20.7721 1.59662 21.0357 1.9038 21.0357H2.67534L6.31507 13.2329C6.5207 12.7971 6.90927 12.4448 7.31999 12.4448H16.2338L16.2368 9.3047C16.6931 9.30757 16.7653 9.29443 17.2782 9.30757V12.4448H21.3664C21.8492 12.4501 22.2558 12.956 21.9025 13.6486Z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5 2.36667V10.5333",
    stroke: "#FFF",
    strokeWidth: 1.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.41675 6.45001H13.5834",
    stroke: "#FFF",
    strokeWidth: 1.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_164:895"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    fill: "#FFF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAddItems2);
export default __webpack_public_path__ + "static/media/ic-add_items2.a4675e4fd55e9a3dcc60801d3779a5a5.svg";
export { ForwardRef as ReactComponent };